import { Component, Event, h } from '@stencil/core';
import { configStore, eventStore, i18nStore } from '../../core/stores';
import { EventEmitter } from '@stencil/core';
import { EventDataType } from '../../core/stores/EventStore';
import { SearchMapState } from '../../core/stores/SearchMapStore.type';

@Component({
  tag: 'hcl-sdk-event-wrapper',
  shadow: false,
})
export class HclSdkEventWrapper {
  @Event() onHCLData: EventEmitter<any>;
  @Event() onHCODetail: EventEmitter<SearchMapState['hcoDetail'] | null>;
  @Event() onHCPDetail: EventEmitter<SearchMapState['individualDetail'] | null>;
  @Event() onHCOs: EventEmitter<SearchMapState['hcos'] | null>;
  @Event() onHCPs: EventEmitter<SearchMapState['specialties'] | null>;
  @Event() onLocaleChange: EventEmitter<string>

  triggerEventConfig(typeEmit: 'HCPDetail' | 'HCODetail' | 'HCOs' | 'HCPs' | 'HCL', data: any, originalType?: 'HCPDetail' | 'HCODetail' | 'HCOs' | 'HCPs') {
    switch (typeEmit) {
      case 'HCPDetail': {
        this.onHCPDetail.emit(data);
        configStore.state.onHCPDetail?.(data);
        break;
      }
      case 'HCODetail': {
        this.onHCODetail.emit(data);
        configStore.state.onHCODetail?.(data);
        break;
      }
      case 'HCPs': {
        this.onHCPs.emit(data);
        configStore.state.onHCPs?.(data);
        break;
      }
      case 'HCOs': {
        this.onHCOs.emit(data);
        configStore.state.onHCOs?.(data);
        break;
      }
      case 'HCL': {
        this.onHCLData.emit({ type: originalType, data });
        configStore.state.onHCLData?.({ type: originalType, data });
        break;
      }
      default: {
        break;
      }
    }
  }

  emitEvent(eventType: EventDataType) {
    switch (eventType) {
      case 'HCODetail': {
        this.triggerEventConfig('HCODetail', eventStore.getHCODetail());
        this.triggerEventConfig('HCL', eventStore.getHCODetail(), 'HCODetail');
        break;
      }
      case 'HCPDetail': {
        this.triggerEventConfig('HCPDetail', eventStore.getHCPDetail());
        this.triggerEventConfig('HCL', eventStore.getHCPDetail(), 'HCPDetail');
        break;
      }
      case 'HCOs': {
        this.triggerEventConfig('HCOs', eventStore.getHCOs());
        this.triggerEventConfig('HCL', eventStore.getHCOs(), 'HCOs');
        break;
      }
      case 'HCPs': {
        this.triggerEventConfig('HCPs', eventStore.getHCPs());
        this.triggerEventConfig('HCL', eventStore.getHCPs(), 'HCPs');
        break;
      }
      default: {
        break;
      }
    }
  }
  emitExitEvent(eventType: EventDataType) {
    switch (eventType) {
      case 'HCODetail-leave': {
        this.triggerEventConfig('HCODetail', null);
        break;
      }
      case 'HCPDetail-leave': {
        this.triggerEventConfig('HCPDetail', null);
        break;
      }
      case 'HCOs-leave': {
        this.triggerEventConfig('HCOs', null);
        break;
      }
      case 'HCPs-leave': {
        this.triggerEventConfig('HCPs', null);
        break;
      }
      default: {
        break;
      }
    }
  }

  componentWillLoad() {
    const { currentDisplayType, exitDisplayType } = eventStore.state;
    currentDisplayType.subscribe({
      next: value => {
        this.emitEvent(value);
      },
    });
    exitDisplayType.subscribe({
      next: value => {
        this.emitExitEvent(value);
      },
    });
    i18nStore.onChange('lang', (data: string) => {
      this.onLocaleChange.emit(data)
      configStore.state.onLocaleChange?.(data)
    })
  }

  render() {
    return <slot />;
  }
}
